import React from "react";
import { Box, createStyles, getStylesRef } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddButton from "../../../components/AddButton";
import FacilityTable from "../../../components/FacilityTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import FacilityModal from "../../../containers/FacilityModal";
import { getAllFacilities, getAllFacilityTypes } from "../../../services";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { LuBuilding } from "react-icons/lu";
import { CiSettings } from "react-icons/ci";
import RemainingCounts from "../../../components/RemainingCounts";
import swal from "sweetalert";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },

  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 10,
    marginTop: 50,
    flexWrap: "wrap",
    [theme.fn.smallerThan("sm")]: {
      marginTop: 20,
      justifyContent: "flex-start",
    },
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "#FFBA45",
    borderRadius: 5,
    cursor: "pointer",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
}));

const Facility = (props) => {
  const { facilities } = useSelector((state) => state.facility);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });

  useEffect(() => {
    getAllFacilityTypes();
    TrackPageView("Facility");
  }, []);

  useEffect(() => {
    getAllFacilities(currentPage);
  }, [currentPage]);


  useEffect(() => {
    const activeFacilitiesCount =
      facilities?.facilities?.filter(
        (item) => item.active === true && item.deleted === false,
      ).length || 0;


    const allowedFacilities = profile?.subscription?.packageId?.facility || 0;
    setCount(Number(allowedFacilities) - Number(activeFacilitiesCount));
  }, [facilities, profile]);

  const handleAddFacility = async () => {
    navigate(`/home/facility/facility/add`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);

  const navigate = useNavigate();
  return (
    <Box fluid className={classes.content}>
      <AppNavbar title="Facility" profile={profile} />
      <FacilityModal opened={opened} close={close} title={"Add New Facility"} />
      <Box px={20} sx={{ background: "#F5F5F5" }}>
        {/* <Box pt={15}>
          <RemainingCounts
            text={"Facilities Remaining"}
            count={
              (profile?.subscription?.packageId?.facility ||
              !profile?.subscription) && profile?.subscription?.packageId?.name !== "Starter"
                ? profile?.subscription?.packageId?.facility || "Unlimited"
                : count
            }
          />
        </Box> */}
        <Box className={classes.btn}>
          <AddButton
            title={"Add Facility"}
            BtnIcon={<LuBuilding size={22} />}
            onClick={handleAddFacility}
          />
          <AddButton
            title={"Settings"}
            BtnIcon={<CiSettings size={25} />}
            onClick={() => navigate("/home/facilitytype")}
            bgLess={true}
          />
        </Box>

        <Box className={classes.table}>
          <FacilityTable facilities={facilities?.facilities} />
          <CustomPagination
            itemsPerPage={10}
            data={facilities?.count}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Facility;
